import React from 'react';
import { Route, Switch } from 'react-router-dom';
import District from './District';
import DistrictsTable from './DistrictsTable';
import Layout from '../../components/Layout';
import RoutingPaths from '../RoutingPath';

const Districts = () => (
  <Layout>
    <Switch>
      <Route
        path={RoutingPaths.Districts}
        component={DistrictsTable}
        exact
      />
      <Route
        path={[`${RoutingPaths.Districts}/:id`, `${RoutingPaths.Districts}/:id/:sectionType`]}
        component={District}
        exact
      />
    </Switch>
  </Layout>
);

export default React.memo(Districts);
